import { createStyles, InputBase, Theme, withStyles } from '@material-ui/core';
import { Colors } from '../../constants/colors';
import { Fonts } from '../../constants/fonts';
import { rgba } from 'polished';

export const Input = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: 5
      },
      '&.invalid': {
        color: Colors.danger,
        '& > input:focus': {
          boxShadow: `0 0 0 0.2rem ${rgba(Colors.danger, 0.25)}`,
          borderColor: 'transparent'
        }
      }
    },
    input: {
      borderRadius: 6,
      backgroundColor: Colors.white,
      border: '1px solid ' + Colors.borderColor,
      fontSize: 16,
      fontFamily: Fonts.base,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 6,
        backgroundColor: Colors.white,
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
      }
    },
    multiline: {
      lineHeight: 1.6,
      padding: 0
    }
  })
)(InputBase);
